<template>
  <div class="deal-card mb-2">
    <div class="background-left-revision" />
    <div class="d-flex justify-content-between align-items-start mb-2">
      <div class="d-flex flex-column">
        <b-avatar-group
          :overlap="(deal.user_networks || []).length > 1 ? 0.65 : 0"
          size="25"
          v-if="(deal.user_networks || []).length"
        >
          <b-avatar
            v-for="item in deal.user_networks || []"
            :key="item.uuid"
            variant="ligth"
            :id="'tooltip-network-' + item.uuid"
            size="25"
            button
          >
            <b-img
              :src="getIconWhite(item.network)"
              :class="getIconColor(item.network, false)"
              fluid
            />

            <b-popover
              :target="'tooltip-network-' + item.uuid"
              triggers="hover focus"
              placement="top"
              container="body"
            >
              <strong>@{{ item.username }}</strong>
            </b-popover>
          </b-avatar>
        </b-avatar-group>

        <small class="mt-1">
          Colaboración personalizada en
          {{
            (deal.user_networks || [])
              .map((n) => formatNetworkName(n.network))
              .join(", ")
          }}
        </small>
      </div>

      <div class="price-box">
        <span class="price"> ${{ separatebycomma(deal.price) }} </span>
        <span class="currency"> USD </span>
      </div>
    </div>

    <p class="avenir-medium text-overflow">{{ deal.title }}</p>

    <p class="avenir-medium text-overflow">{{ deal.description }}</p>

    <p class="d-flex flex-wrap">
      <span class="d-flex align-items-center mr-1">
        <b-icon icon="shield-check" class="mr-05" />
        <span class="avenir-medium">
          {{
            $t("creator.licensing").find(
              (licence) => licence.value === deal.licensing
            ).text
          }}
        </span>
      </span>
    </p>

    <b-button
      class="blue-button btn-buy"
      variant="blue-button"
      @click="buyAction"
      v-if="is_brand"
      pill
    >
      <span v-if="!buy_loader">Aceptar y Pagar</span
      ><b-spinner small class="mt-0" v-if="buy_loader"></b-spinner>
    </b-button>
  </div>
</template>
  
<script>
import { separatebycomma } from "@/libs/utils/formats";
import {
  BAvatarGroup,
  BAvatar,
  BImg,
  BPopover,
  BButton,
  BSpinner,
} from "bootstrap-vue";
import { getIconWhite, getIconColor } from "@/libs/utils/icons";
import { isBrand } from "@/domain/user/access.domain";
import { getUserData } from "@/libs/utils/user";
import { makeExecuteProposalBuyFlowUseCase } from "@/application/proposals/loadProposalsDeals.usecase";
import { proposalsDealsRepository } from "@/infrastructure/proposals/proposals.repository";
import { showToast } from '@/libs/utils/others';

export default {
  name: "DealCard",

  components: {
    BAvatarGroup,
    BAvatar,
    BImg,
    BPopover,
    BButton,
    BSpinner,
  },

  props: {
    deal: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      separatebycomma,
      getIconColor,
      getIconWhite,
      buy_loader: false,
    };
  },
  computed: {
    user_data() {
      return getUserData();
    },
    is_brand() {
      return isBrand(this.user_data);
    },
  },
  methods: {
    async buyAction() {
      this.buy_loader = true;
      console.log(this.deal.uuid);
      try {
        const executeBuyFlow = makeExecuteProposalBuyFlowUseCase(
          { proposalsDealsRepository },
          {
            deal_selected: this.deal,
          }
        );

        const result = await executeBuyFlow();

        window.location.href = result.url;
      } catch (error) {
        showToast(this, 'danger', 'XCircleIcon', this.$t('creator.titleErrorBuyDeal'));
      } finally {
        this.buy_loader = false;
      }
    },
    formatNetworkName(network) {
      const map = {
        instagram: "Instagram",
        tiktok: "TikTok",
        youtube: "YouTube",
        facebook: "Facebook",
        twitter: "X",
        linkedin: "LinkedIn",
        pinterest: "Pinterest",
        snapchat: "Snapchat",
        telegram: "Telegram",
        whatsapp: "WhatsApp",
        spotify: "Spotify",
      };

      return map[network] || network;
    },
  },
};
</script>
  
<style scoped>
.deal-card {
  width: 100%;
  background: #ffffff;
  border: 1px solid #e9ecef;
  border-radius: 18px;
  padding: 22px;
  transition: all 0.2s ease;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.03);

  position: relative;
  overflow: hidden;
}

.background-left-revision {
  background-color: #0096fe;
  width: 6px;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}

.price-box {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.price {
  font-size: 20px;
  font-weight: 800;
  color: #111827;
  line-height: 1;
}

.currency {
  color: #9ca3af;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 1px;
  margin-top: 4px;
}

.btn-characteristics {
  display: flex;
  align-items: center;
  color: #3483fa;
  background-color: rgba(65, 137, 230, 0.12);
  border-radius: 999px;
  padding: 8px 12px;
  font-size: 12px;
  font-weight: 700;
  border: none;
}
.text-overflow {
  display: -webkit-box !important;
  -webkit-line-clamp: 1 !important;
  -webkit-box-orient: vertical !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}
</style>